import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useExchangeRates = () => {
  return useQuery({
    queryKey: ["exchange-rates"],
    queryFn: async () => {
      const { data, error } = await supabase.functions.invoke("get-exchange-rates");
      
      if (error) {
        console.error("Error fetching exchange rates:", error);
        // Return fallback rates
        return {
          USD_to_ZAR: 18.5,
          EUR_to_ZAR: 20.0,
          fallback: true,
        };
      }
      
      return data;
    },
    staleTime: 1000 * 60 * 60, // 1 hour
    refetchInterval: 1000 * 60 * 60 * 6, // Refetch every 6 hours
  });
};
